import React, { useEffect, useRef, useState } from 'react';
import { Button, GoogleMap, InputForm } from 'components';
import { toastError, toastSuccess } from 'utils/constants/functions';
import { useQuery } from '@tanstack/react-query';
import { testApi } from 'apis/GraphQL/test';
import { TEST_QUERY } from 'apis/GraphQL/Queries/testQuery';
import { PowerBiComponent } from 'components/PowerBi/PowerBiComponent';
import MapLocation from 'components/Map/MapLocation';
import { Form, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useTitle } from 'contexts/TitleProvider';

const Home = () => {
  const [open, setOpen] = useState(false);
  const [center, setCenter] = useState<any>();
  const [form] = useForm();
  const { setBreadcrumb, setTitle } = useTitle();
  const childRef = useRef<any>(null);

  useEffect(() => {
    setBreadcrumb([]);
    setTitle('');
  }, []);

  const onFinish = (value: any) => {
    setOpen(true);
    setCenter({
      lat: parseFloat(value.lat),
      lng: parseFloat(value.lng),
    });
  };

  const updateLocation = async () => {
    if (childRef && childRef.current) {
      childRef.current.updateLocation();
    }
  };

  const refetchMap = async () => {
    if (childRef && childRef.current) {
      childRef.current.refetchMap();
    }
  };
  return (
    <div className="m-0 border-red-100 w-full h-full">
      {/* <GoogleMap /> */}
      {/* <PowerBiComponent
        myReport={{
          reportId: 'd2b1249f-d950-4074-a487-846667b2bd3a',
          groupId: '175e6400-43d9-48bd-a582-fb4bca86eff2',
        }}
      /> */}

      {/* search */}
      {/* <Form form={form} className="w-1/2" onFinish={onFinish}>
        <Form.Item label="Lat" name={'lat'} initialValue={'10.744714714745694'}>
          <InputForm value={'10.744714714745694'} type="number" />
        </Form.Item>
        <Form.Item label="Lng" name={'lng'} initialValue={'106.65674618989978'}>
          <InputForm value={'106.65674618989978'} type="number" />
        </Form.Item>
        <Button type="submit" title="Search" />
      </Form>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => setOpen(false)}
        closable={false}
        width={'max-content'}
      >
        <Button title="Add" handleOnclick={updateLocation} />
        <MapLocation
          center={center}
          scale={0.8}
          className="w-[600px] h-[400px]"
          ref={childRef}
        />
      </Modal> */}
    </div>
  );
};

export default Home;
